import { Outlet } from 'react-router-dom';

import { HStack } from '@/shared/ui';
import { Header } from '@/widgets/header';

export const BaseLayout = () => {
  return (
    <div className="flex flex-col min-h-screen bg-background text-foreground transition-colors overflow-hidden">
      <Header />
      <HStack gap="24" className="flex-1 p-[1rem]">
        <Outlet />
      </HStack>
    </div>
  );
};
